

























































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import PokemonTypeComponent from '@/components/PokemonTypeComponent.vue';
import {
  Pokemon,
  SelectedPokemon,
  Move,
  TypeEvaluationResults,
} from '../models/pokemon';
import {
  pokemonData,
  allTypes,
  typeWeaknesses,
  typeEffectivenesses,
} from '../utils/pokemonData';

@Component({
  components: {
    PokemonTypeComponent,
  },
})
export default class PokemonTeamBuilder extends Vue {

  // constants from importing

  private allTypes: string[] = allTypes;

  // variables to hold input

  private baseUrl: string = 'https://www.lindazheng.me/poke-team?team=';

  private selectedPokemonUrl: string = '';

  private selectedPokemonNames: string[] = ['', '', '', '', '', '', ''];

  private selectedPokemonMoves: string[][] = [
    ['', '', '', ''],
    ['', '', '', ''],
    ['', '', '', ''],
    ['', '', '', ''],
    ['', '', '', ''],
    ['', '', '', ''],
  ];

  private evalResults: Map<string, TypeEvaluationResults> = new Map<
    string,
    TypeEvaluationResults
  >();

  mounted() {
    console.log('mounted PokemonTeamBuilder');
    console.log(`team: ${this.$route.query.team}`);
    
    if (this.$route.query.team) {
      this.generatedSelectedPokemonAndMovesFromUrl()
    }
  }

  // getters

  get pokemonNames() {
    // console.log('get pokemonNames');
    return pokemonData.map((p: Pokemon) => p.name).filter((p) => !!p);
  }

  get pokemonMap() {
    // console.log('get pokemonMap');
    const map = new Map<string, Pokemon>();
    pokemonData.forEach((p: Pokemon) => map.set(p.name, p));
    return map;
  }

  get movesMap() {
    // console.log('get movesMap');
    const map = new Map<string, Move>();
    pokemonData.forEach((p: Pokemon) => {
      p.moves.forEach((m: Move) => {
        if (!map.has(m.name)) {
          map.set(m.name, m);
        }
      });
    });
    return map;
  }

  // methods

  public evaluateTeam() {
    console.log('evaluating team...');
    this.generateSelectedUrl();

    this.evalResults = new Map<string, TypeEvaluationResults>();

    allTypes.forEach((t: string) => {
      const typeEvalResult: TypeEvaluationResults = new TypeEvaluationResults();

      typeEvalResult.type = t;

      // get pokemon that are weak to type
      typeEffectivenesses!.get(t)!.forEach((weakness: string) => {
        this.selectedPokemonNames.forEach((pokemonName: string) => {
          if (pokemonName && this.pokemonMap.has(pokemonName)) {
            const selectedPokemon: Pokemon = this.pokemonMap.get(pokemonName)!;
            if (
              selectedPokemon.types.indexOf(weakness) > -1 &&
              typeEvalResult.pokemonWeakToType.indexOf(selectedPokemon.name) ===
                -1
            ) {
              typeEvalResult.pokemonWeakToType.push(selectedPokemon.name);
            }
          }
        });
      });

      // get pokemon with moves effective against type
      typeWeaknesses.get(t)!.forEach((effective: string) => {
        for (const selectedPokemonIndex in this.selectedPokemonMoves) {
          const selectedPokemon = this.selectedPokemonNames[selectedPokemonIndex];
          const selectedMoves = this.selectedPokemonMoves[selectedPokemonIndex];
          selectedMoves.forEach((m: string) => {
            if (
              m &&
              this.movesMap.has(m) &&
              this.movesMap.get(m)!.type === effective
            ) {
              if (
                !typeEvalResult.pokemonWithMovesEffectiveAgainstType.has(
                  selectedPokemon,
                )
              ) {
                typeEvalResult.pokemonWithMovesEffectiveAgainstType.set(
                  selectedPokemon,
                  [],
                );
              }
              typeEvalResult.pokemonWithMovesEffectiveAgainstType!
                .get(selectedPokemon)!
                .push(m);
            }
          });
        }
      });

      this.evalResults.set(t, typeEvalResult);
    });
  }

  public generateSelectedUrl() {
    console.log('generateSelectedUrl');
    let pokemonUrl = '';

    for (let i of [0,1,2,3,4,5]) {
      if (this.selectedPokemonNames[i]) {
        pokemonUrl += `${i > 0 ? '::' : ''}${this.selectedPokemonNames[i]}=${JSON.stringify(this.selectedPokemonMoves[i])}`;
      }
    }
    this.selectedPokemonUrl = `${this.baseUrl}${pokemonUrl}`;
  }

  public generatedSelectedPokemonAndMovesFromUrl() {
    console.log('generatedSelectedPokemonAndMovesFromUrl');
    let i = 0;
    (this.$route.query.team as string).split('::').forEach((s: string) => {
      this.selectedPokemonNames[i] = s.split('=')[0];
      this.selectedPokemonMoves[i] = JSON.parse(s.split('=')[1]);
      i++;
    });
    this.evaluateTeam();
  }

  @Watch('selectedPokemonNames', { deep: true })
  public selectedPokemonUpdate(newValue: string[], oldValue: string[]) {
    // console.log(
    //   `selectedPokemonNames updated from ${oldValue}, to ${newValue}`,
    // );

    let doEval = true;

    for (const val of newValue) {
      if (!this.pokemonMap.get(val) && val) {
        doEval = false;
        break;
      }
    }

    if (doEval) {
      this.evaluateTeam();
    }
  }

  @Watch('selectedPokemonMoves', { deep: true })
  public selectedPokemonMovesUpdate(newValue: string[][], oldValue: string[][]) {
    // console.log(
    //   `selectedPokemonMoves updated from ${oldValue}, to ${newValue}`,
    // );

    let doEval = true;

    loop1: for (const pokeMove of newValue) {
      loop2: for (const move of pokeMove) {
        if (!this.movesMap.get(move) && move) {
          doEval = false;
          break loop1;
        }
      }
    }

    if (doEval) {
      this.evaluateTeam();
    }
  }
}
